import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Recycling from "@/components/site/Recycling";
import WhyEWS from "@/components/site/WhyEWS";
import Testimonials from "@/components/site/Testimonials";
import ServiceAreaCheck from "@/components/site/ServiceAreaCheck";
import QuoteForm from "@/components/site/QuoteForm";
import SavingsCalculator from "@/components/site/SavingsCalculator";
import Seo from "@/components/site/Seo";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { BUSINESS_SCHEMA } from "@/lib/data";
import { useI18n } from "@/i18n";

export default function Home() {
  const { t, localePath } = useI18n();
  return (
    <>
      <Seo
        title={t("home.seoTitle")}
        description={t("home.seoDesc")}
        path="/"
        jsonLd={BUSINESS_SCHEMA}
      />
      <Hero />
      <Marquee />
      <Services />
      <section className="relative bg-[#F0EFEA] py-24" id="savings" data-testid="home-savings-section">
        <div className="max-w-[1100px] mx-auto px-5 sm:px-8 grid lg:grid-cols-[0.9fr_1.1fr] gap-10 items-center">
          <div>
            <span className="font-mono-tech text-[11px] uppercase tracking-[0.22em] text-emerald-700">{t("home.savings.eyebrow")}</span>
            <h2 className="mt-3 font-display font-extrabold tracking-tight leading-[1.05] text-3xl sm:text-4xl text-[#0B0F14]">
              {t("home.savings.title")}
            </h2>
            <p className="mt-4 text-slate-600 leading-relaxed">
              {t("home.savings.body")}
            </p>
            <Link to={localePath("/savings-calculator") + "#how-it-works"} data-testid="home-savings-patent"
              className="group mt-5 inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white border border-[#E7E5DF] shadow-sm text-[11px] font-mono-tech uppercase tracking-wider text-slate-500 hover:text-emerald-700 hover:border-emerald-500/50 transition-colors">
              <ShieldCheck size={13} className="text-emerald-600" /> {t("home.savings.patent")}
              <span className="text-emerald-700 font-bold group-hover:underline">{t("home.savings.learn")}</span>
            </Link>
          </div>
          <SavingsCalculator variant="home" />
        </div>
      </section>
      <Recycling />
      <WhyEWS />
      <Testimonials />
      <ServiceAreaCheck />
      <QuoteForm />
    </>
  );
}
